import dayjs from 'dayjs';

const DELIMITER = ';';

const downloadCorrelation = (data, locale) => {
  const decimalSeparator = getDecimalSeparator(locale);
  download(correlation, data, decimalSeparator);
};

const downloadEvolution = (data, locale) => {
  const decimalSeparator = getDecimalSeparator(locale);
  download(evolution, data, decimalSeparator);
};

const getDecimalSeparator = (locale) => {
  const numberWithDecimalSeparator = 1.1;
  return Intl.NumberFormat(locale.replace('_', '-'))
    .formatToParts(numberWithDecimalSeparator)
    .find(part => part.type === 'decimal')
    .value;
};

const download = (apply, data, decimalSeparator) => {
  const hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(apply(data, decimalSeparator));
  hiddenElement.target = '_blank';
  hiddenElement.download = 'output.csv';
  hiddenElement.click();
};

const correlation = (data, decimalSeparator) => {
  let csvData = header(data);

  let timestamps = [];
  data.forEach(variable => {
    variable.data.forEach(value => {
      if (!timestamps.includes(value.timestamp)) {
        timestamps.push(value.timestamp);
      }
    });
  });
  timestamps.sort((a, b) => {
    return a - b;
  });
  timestamps.forEach(timestamp => {
    const values = [];
    let correlatedValues = true;
    for (let i = 0; i < data.length; i++) {
      let valueObject = data[i].data.find(value => {
        return value.timestamp === timestamp;
      });
      if (typeof valueObject === 'undefined') {
        correlatedValues = false;
        break;
      } else {
        values.push(valueObject.value.replace('.', decimalSeparator));
      }
    }
    if (correlatedValues) {
      csvData += String(timestamp).replace('.', decimalSeparator) + DELIMITER + dayjs(timestamp * 1000).format('DD/MM/YYYY H:mm:ss') + DELIMITER + values.join(DELIMITER) + '\n';
    }
  });
  return csvData;
};

const evolution = (data, decimalSeparator) => {
  let csvData = header(data);

  let timestamps = [];
  data.forEach(variable => {
    variable.data.forEach(value => {
      if (!timestamps.includes(value.timestamp)) {
        timestamps.push(value.timestamp);
      }
    });
  });
  timestamps.sort((a, b) => {
    return a - b;
  });
  timestamps.forEach(timestamp => {
    const values = [];
    data.forEach(variable => {
      let valueObject = variable.data.find(value => {
        return value.timestamp === timestamp;
      });
      values.push(typeof valueObject !== 'undefined' ? valueObject.value.replace('.', decimalSeparator) : null);
    });
    csvData += String(timestamp).replace('.', decimalSeparator) + DELIMITER + dayjs(timestamp * 1000).format('DD/MM/YYYY H:mm:ss') + DELIMITER + values.join(DELIMITER) + '\n';
  });
  return csvData;
};

const header = (data) => {
  let csvFields = ['timestamp', 'datetime'];
  data.forEach(variable => {
    csvFields.push(variable.metadata.label);
  });
  return csvFields.join(DELIMITER) + '\n';
};

export default {
  downloadCorrelation,
  downloadEvolution
};



// WEBPACK FOOTER //
// ./src/layouts/explorer/explorerToCSV.js